import { DateTime } from 'luxon'

import { SxProps } from '@mui/material'
import { isTodayDate } from '@shared/utils'

import { ChatDate } from './index.styles'

const ChatDateTime = ({ format, date, sx }: { date: string; format?: string; sx?: SxProps }) => {
  const isTodayMessage = isTodayDate(date)

  return <ChatDate sx={sx}>{DateTime.fromISO(date).toFormat(format ?? isTodayMessage ? 'T' : 'MMM dd')}</ChatDate>
}

export default ChatDateTime
